export default __webpack_public_path__ + "static/hingurana-group-df1d0a4c4f7a37a5dc38028828787b46.png";